import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { App, IAppParams } from './App';

const chatContainer:HTMLDivElement = document.getElementById('cca-etl-chat-app') as HTMLDivElement;

if (chatContainer) {

    // Wordpress supplies user, room, and base endpoing for WP fetches
    const config:IAppParams = {
        user: chatContainer.dataset.user,
        userlinkname: chatContainer.dataset.userlinkname,
        room: chatContainer.dataset.room,
        endpoint: chatContainer.dataset.endpoint,
        fbAuthToken: chatContainer.dataset.fbauthtoken
    }

    ReactDOM.render(
        <App  {...config} />,
        chatContainer  
    );
}